var map = {
	"./bootstrap/bootstrap.module": [
		"./src/app/pages/bootstrap/bootstrap.module.ts",
		"bootstrap-bootstrap-module"
	],
	"./charts/charts.module": [
		"./src/app/pages/charts/charts.module.ts",
		"default~app-pages-pages-module~charts-charts-module~maps-maps-module",
		"default~app-pages-pages-module~charts-charts-module",
		"common",
		"charts-charts-module"
	],
	"./editors/editors.module": [
		"./src/app/pages/editors/editors.module.ts",
		"editors-editors-module"
	],
	"./extra-components/extra-components.module": [
		"./src/app/pages/extra-components/extra-components.module.ts",
		"common",
		"extra-components-extra-components-module"
	],
	"./forms/forms.module": [
		"./src/app/pages/forms/forms.module.ts",
		"forms-forms-module"
	],
	"./maps/maps.module": [
		"./src/app/pages/maps/maps.module.ts",
		"default~app-pages-pages-module~charts-charts-module~maps-maps-module",
		"default~app-pages-pages-module~maps-maps-module",
		"default~maps-maps-module~modal-overlays-modal-overlays-module",
		"common",
		"maps-maps-module"
	],
	"./miscellaneous/miscellaneous.module": [
		"./src/app/pages/miscellaneous/miscellaneous.module.ts",
		"common"
	],
	"./modal-overlays/modal-overlays.module": [
		"./src/app/pages/modal-overlays/modal-overlays.module.ts",
		"default~maps-maps-module~modal-overlays-modal-overlays-module",
		"common",
		"modal-overlays-modal-overlays-module"
	],
	"./tables/tables.module": [
		"./src/app/pages/tables/tables.module.ts",
		"common",
		"tables-tables-module"
	],
	"./ui-features/ui-features.module": [
		"./src/app/pages/ui-features/ui-features.module.ts",
		"ui-features-ui-features-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~app-pages-pages-module~charts-charts-module~maps-maps-module",
		"default~app-pages-pages-module~charts-charts-module",
		"default~app-pages-pages-module~maps-maps-module",
		"common",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;